import {
    Button,
    Col,
    Container,
    Form,
    Modal,
    Row,
    Tab,
    Table,
    Tabs,
} from "react-bootstrap";
import Services from "../../API/services";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Layout from "../../layout";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpenseSubCategory from "./ExpenseSubCategory";

export default function ExpensesCategory() {

    const [expCategory, setExpCategory] = useState([]);

    const [showCategory, setShowCategory] = useState(false);
    const [cateEditMode, setCateEditMode] = useState(false)

    const [showSub, setShowSub] = useState(false);
    const [subEditMode, setSubEditMode] = useState(false)

    const { register: register1, handleSubmit: handleSubmit1, reset: reset1, formState: { errors: errors1 } } = useForm();
    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm();

    const onHide = () => {
        setShowCategory(false);
        setShowSub(false)

        // setCateEditMode(false)
        // setSubEditMode(false)

        reset1()
        reset2()
    };

    const handleCateEdit = (data) => {
        setShowCategory(true)
        setCateEditMode(data)
    }

    const handleSubEdit = (sub) => {
        setShowSub(true)
        setSubEditMode(sub)
    }

    const fetchExpensesCategory = async () => {
        const res = await Services.globalService.getExpensesCategories()
        if (res.status === 200 && res.data.success === true) {
            setExpCategory(res.data.data)
        }
    }

    useEffect(() => {
        fetchExpensesCategory()
    }, [])


    const onCateSubmit = async (data) => {
        const payload = { categoryName: data.categoryName }
        if (cateEditMode) {
            const res = await Services.globalService.editExpenseCategory(payload, cateEditMode.id)
            if (res.status === 200 && res.data.success === true) {
                toast.success(res.data.message);
                reset1()
                onHide()
                fetchExpensesCategory()
            }
        }
        else {
            const res = await Services.globalService.addExpenseCategory(payload)
            if (res.status === 201 && res.data.success === true) {
                toast.success("Category Created Successfull");
                reset1()
                onHide()
                fetchExpensesCategory()
            }
        }
    }

    const onSubSubmit = async (data) => {
        const payload = { expenceCatId: showSub.id, subCategoryName: data.subCategoryName }

        if (subEditMode) {
            const res = await Services.globalService.editExpenseSubCategory(payload, subEditMode.id)
            if (res.status === 200 && res.data.success === true) {
                toast.success(res.data.message);
                reset1()
                onHide()
                fetchExpensesCategory()
            }
        }
        else {
            const res = await Services.globalService.addExpenseSubCategory(payload)
            if (res.status === 201 && res.data.success === true) {
                toast.success("Category Created Successfull");
                reset1()
                onHide()
                fetchExpensesCategory()
            }
        }
    }

    useEffect(() => {
        if (cateEditMode) {
            reset1({ categoryName: cateEditMode.categoryName });
        } else {
            reset1({ categoryName: "" });
        }
    }, [cateEditMode]);

    useEffect(() => {
        if (subEditMode) {
            reset2({ subCategoryName: subEditMode.subCategoryName });
        } else {
            reset2({ subCategoryName: "" });
        }
    }, [subEditMode]);

    return (
        <Layout
            title="Expenses Category"
            extraButton="Add Category"
            extraBtnHandler={() => setShowCategory(true)}
        >
            <div className="flex justify-content-center row">
                <ul className="Module mt-2 categoryWrap w-100">
                    {
                        expCategory?.map((category) => {
                            return (
                                <li key={category.id} className="Module_Item mb-4 border rounded shadow-sm px-1 px-md-0">
                                    <label className="d-flex align-items-center justify-content-between p-1 px-2 p-md-2">
                                        <div className="d-flex gap-md-2 align-items-center gap-1 p-0 col-md-7 col-7">
                                            <FontAwesomeIcon icon="fa-solid fa-list" color="#0076FC" />
                                            <span>{category.categoryName}</span>
                                        </div>
                                        <div className="d-flex justify-content-end gap-2 gap-md-3 p-0 col-4">
                                            <button
                                                className="m-0 p-0 btn border-primary border btn-sm px-md-2 px-1"
                                                style={{ fontSize: '0.7rem' }}
                                                onClick={() => setShowSub(category)}
                                            >
                                                <FontAwesomeIcon
                                                    icon="fa-solid fa-plus"
                                                    color="#0076FC"
                                                />Add
                                            </button>
                                            <button className="btn m-0 p-0" onClick={() => handleCateEdit(category)}
                                            >
                                                <FontAwesomeIcon
                                                    icon="fa-solid fa-pen-to-square"
                                                    color="#0076FC"
                                                />
                                            </button>
                                        </div>
                                    </label>
                                    <ul className="Module_inner p-1 pt-2 gap-0">
                                        {
                                            category?.ExpenceSubCategories?.map((sub) => {
                                                return (
                                                    <li key={sub.id} className="d-flex align-items-center">
                                                        <label className="module_sub1">
                                                            <div className="d-flex flex-column align-items-start">
                                                                <span className="text-uppercase">{sub?.subCategoryName}</span>
                                                            </div>
                                                        </label>
                                                        <button className="btn m-0 p-0" onClick={() => handleSubEdit(sub)}>
                                                            <FontAwesomeIcon
                                                                icon="fa-solid fa-pen-to-square"
                                                                color="#0076FC"
                                                            />
                                                        </button>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </li>
                            )
                        })
                    }

                </ul>
            </div>

            <Modal show={showCategory} onHide={onHide} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{cateEditMode ? 'Edit' : 'Add'} Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit1(onCateSubmit)} className="popup-form">
                        <Col xs={12}>
                            <div className="form-group">
                                <label className="label form-label">Category Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register1("categoryName", { required: "Category is required" })}
                                    defaultValue={cateEditMode ? cateEditMode.categoryName : ''}
                                    placeholder="Enter your name"
                                />
                                {errors1.categoryName && <p className="error-text"><span>{errors1.categoryName.message}</span></p>}
                            </div>
                        </Col>
                        <Col xs={12} className="form-group">
                            <button type="submit" className="btn btn-sm btn btn-success">Submit</button>
                        </Col>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* <ExpenseSubCategory show={showSub} onHide={onHide} editMode={subEditMode} categoryAction={fetchExpensesCategory} /> */}

            <Modal show={showSub} onHide={onHide} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{subEditMode ? 'Edit' : 'Add'} Sub Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit2(onSubSubmit)} className="popup-form">
                        <Col xs={12}>
                            <div className="form-group">
                                <label className="label form-label">Sub Category Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register2("subCategoryName", { required: "Sub Category is required" })}
                                    defaultValue={subEditMode ? subEditMode.subCategoryName : ''}
                                    placeholder="Enter your name"
                                />
                                {errors2.subCategoryName && <p className="error-text"><span>{errors2.subCategoryName.message}</span></p>}
                            </div>
                        </Col>
                        <Col xs={12} className="form-group">
                            <button type="submit" className="btn btn-sm btn btn-success">Submit</button>
                        </Col>
                    </Form>
                </Modal.Body>
            </Modal>
        </Layout>
    );
}
